import React from "react";
import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";

export default function ContactUs() {
  
  return (
    <div className="Contact-Us pt-[160px] sm:pt-0">
      <Helmet>
        <title>CONTACT US - Mean3 Software Solutions</title>
      </Helmet>
      <Section1 />
      <Section2 />
    </div>
  );
}
